import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import VerifyBanner from "@/components/VerifyBanner";
import ForcePasswordChange from "@/components/ForcePasswordChange";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import TravelerDashboard from "@/pages/TravelerDashboard";
import ProviderDashboard from "@/pages/ProviderDashboard";
import AgentDashboard from "@/pages/AgentDashboard";
import BecomeAnAgent from "@/pages/BecomeAnAgent";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import BookingConfirmation from "@/pages/BookingConfirmation";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Community from "@/pages/Community";
import ThreadDetail from "@/pages/ThreadDetail";
import AdminPanel from "@/pages/AdminPanel";
import AdminLogin from "@/pages/AdminLogin";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cars from "@/pages/Cars";
import CarDetail from "@/pages/CarDetail";
import CarBookingConfirmation from "@/pages/CarBookingConfirmation";
import VerifyEmail from "@/pages/VerifyEmail";
import Profile from "@/pages/Profile";
import AdminHostVerify from "@/pages/AdminHostVerify";
import AdminCarOperator from "@/pages/AdminCarOperator";
import LandingPage from "@/components/LandingPage";
import { DESTINATIONS, CATEGORIES } from "@/lib/landingData";

function App() {
  return (
    <div className="App min-h-screen bg-[#060810]">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
          <Navbar />
          <div className="pt-16">
            <VerifyBanner />
            <ForcePasswordChange />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/cars" element={<Cars />} />
              <Route path="/cars/:id" element={<CarDetail />} />
              <Route path="/listing/:id" element={<ListingDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/community" element={<Community />} />
              <Route path="/community/:id" element={<ThreadDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/grenada" element={<LandingPage config={DESTINATIONS.grenada} />} />
              <Route path="/barbados" element={<LandingPage config={DESTINATIONS.barbados} />} />
              <Route path="/st-vincent" element={<LandingPage config={DESTINATIONS["st-vincent"]} />} />
              <Route path="/saint-lucia" element={<LandingPage config={DESTINATIONS["saint-lucia"]} />} />
              <Route path="/turks-caicos" element={<LandingPage config={DESTINATIONS["turks-caicos"]} />} />
              <Route path="/atv-tours" element={<LandingPage config={CATEGORIES["atv-tours"]} />} />
              <Route path="/boat-tours" element={<LandingPage config={CATEGORIES["boat-tours"]} />} />
              <Route path="/shore-excursions" element={<LandingPage config={CATEGORIES["shore-excursions"]} />} />
              <Route path="/water-activities" element={<LandingPage config={CATEGORIES["water-activities"]} />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/register" element={<Register />} />
              <Route path="/become-an-agent" element={<BecomeAnAgent />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute role="admin">
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/hosts/:id/verify"
                element={
                  <ProtectedRoute role="admin">
                    <AdminHostVerify />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/car-operators/:id"
                element={
                  <ProtectedRoute role="admin">
                    <AdminCarOperator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/booking/:id/confirmation"
                element={
                  <ProtectedRoute>
                    <BookingConfirmation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/car-booking/:id/confirmation"
                element={
                  <ProtectedRoute>
                    <CarBookingConfirmation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <TravelerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/provider"
                element={
                  <ProtectedRoute role="provider">
                    <ProviderDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/agent"
                element={
                  <ProtectedRoute role="agent">
                    <AgentDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
